var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
var ERROR_FORBIDDEN = "403: Forbidden";
export function shouldShowTc2Error(errMsg) {
    return errMsg.includes(ERROR_FORBIDDEN);
}
var Tc2Error = /** @class */ (function (_super) {
    __extends(Tc2Error, _super);
    function Tc2Error() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Tc2Error.prototype.render = function () {
        return (React.createElement("p", null,
            "You must be in the \"Micros Just-In-Time\" access level in",
            " ",
            React.createElement("a", { href: "https://ssam.prod.atl-paas.net/containers/micros-sv--" + this.props.serviceId + "/#jit", target: "_blank", rel: "noopener noreferrer" }, "your service's SSAM container"),
            " ",
            "to perform this operation, see",
            " ",
            React.createElement("a", { href: "https://go.atlassian.com/micros-tc2-compliance", target: "_blank", rel: "noopener noreferrer" }, "go/micros-tc2-compliance"),
            " ",
            "for details.",
            React.createElement("br", null),
            React.createElement("br", null),
            React.createElement("i", null, ERROR_FORBIDDEN)));
    };
    return Tc2Error;
}(React.Component));
export { Tc2Error };
